import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { displayLoader, hiddenLoader } from "../../stores/loading";
import { displayInput } from "./DisplayInput";


export function Form({ form, formHiden = {}, search, reset }: any) {
    const dispatch = useDispatch();
    const load = useSelector((state: any) => state.loader.value)
    let [error, setError] = useState('');
    let [searchParams, setSearchParams] = useSearchParams();
    let [openFilter, setOpenFilter] = useState(false);
    let [valueform, setValueForm] = useState({});
    let [loadform, setLoadForm] = useState(false);


    useEffect(() => {
        let checkForm = { ...form, ...formHiden } as any
        checkForm = checkForm.order_id ? {...checkForm, order_id : checkForm.order_id.trim()} : checkForm
        const formSearch = () => {
            let valueFormulaire = {} as any;
            Object.keys(checkForm).forEach(element => {
                if (checkForm[element].type === 'multiple' && searchParams.get(element)) {
                    valueFormulaire[element] = searchParams.getAll(element)
                } else {
                    valueFormulaire[element] = searchParams.get(element)
                }
                
            })
            setValueForm(valueFormulaire);
            if (valueFormulaire && Object.keys(valueFormulaire).filter((k: any) => valueFormulaire[k] !== null && valueFormulaire[k].length !== 0).length > 0) {
                search(valueFormulaire);
                setLoadForm(true)
            } else {
                setLoadForm(true)
            }
        }

        formSearch();

        // eslint-disable-next-line 
    }, []);


    function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
        dispatch(displayLoader());
        let checkForm = { ...form, ...formHiden } as any
        checkForm = checkForm.order_id ? {...checkForm, order_id : checkForm.order_id.trim()} : checkForm
        setError('');
        let newValueFormulaire = {} as any;
        event.preventDefault();
        let formData = new FormData(event.currentTarget);

        for (var pair of formData.entries()) {

            if ((checkForm[pair[0]] === 'string' || checkForm[pair[0]] === 'date' || checkForm[pair[0]] === 'datetime') && pair[1]) {
                newValueFormulaire[pair[0]] = pair[1];
            } else {
                if (pair[1]) {
                    if (newValueFormulaire[pair[0]]) {
                        newValueFormulaire[pair[0]].push(pair[1])
                    } else {
                        newValueFormulaire[pair[0]] = [pair[1]]
                    }
                }
            }
        }

        if (newValueFormulaire && Object.keys(newValueFormulaire).filter((k: any) => newValueFormulaire[k] !== null).length > 0) {
            newValueFormulaire = newValueFormulaire.order_id ? {...newValueFormulaire, order_id : newValueFormulaire.order_id.trim()} : newValueFormulaire
            setValueForm(newValueFormulaire);
            search(newValueFormulaire)
            setSearchParams(newValueFormulaire);
        } else {
            dispatch(hiddenLoader());
            setError('Minimum one field required')
        }
    }

    function resetForm() {
        if (document && document.getElementById("myform") !== null) {
            let test = document.getElementById("myform") as any;
            test.reset();
        }

        setValueForm({});
        setSearchParams({});
        reset();
    }

    return (<>
    
        {loadform && <form onSubmit={handleSubmit} id="myform"  >
            <div className="vtmn-grid vtmn-grid-cols-4 vtmn-gap-0" >
                {Object.keys(form).map((element, index) => {
                    return displayInput(form, element, valueform)
                })}
            </div>
            <div className="block vtmn-mt-4 vtmn-mb-1">
                {Object.keys(formHiden).length > 0 && <div className="vtmn-divider vtmn-divider_orientation--horizontal vtmn-cursor-pointer"
                    onClick={() => setOpenFilter(!openFilter)} role="separator">
                    <p className="vtmn-mr-2">More Filter</p><span className={!openFilter ? 'vtmx-chevron-down-line' : 'vtmx-chevron-up-line'} aria-hidden="true"></span>
                </div>}
            </div>
            {openFilter && <div className="vtmn-grid vtmn-grid-cols-4 vtmn-gap-0 vtmn-mb-4" >
                {Object.keys(formHiden).map((element, index) => {
                    return displayInput(formHiden, element, valueform)
                })}
            </div>}
            <div className="vtmn-flex" >
                <button className="vtmn-btn vtmn-btn_size--stretched vtmn-mr-4" type="submit" disabled={load}>Search</button>
                <div className="vtmn-btn vtmn-btn_variant--secondary  vtmn-btn--icon-alone"
                    onClick={() => { resetForm() }}>
                    <span className="vtmx-close-line" aria-hidden="true"></span>
                    <span className="vtmn-sr-only">remove</span>
                </div>
            </div>
        </form> }
        {error && <div className="vtmn-text-center vtmn-text-sm vtmn-m-2" style={{ color: 'var(--vtmn-semantic-color_content-negative)' }}>
            {error}
        </div>}
        { load && <div className="vtmn-loader vtmn-loader_size--large vtmn-m-auto vtmn-mt-4">
            <span className="vtmn-sr-only"></span>
        </div> }
    </>
    )
}